import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { getCurrent } from "."
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { computeDisplayType } from "helpers/analyze"
import { getModelCategories, getModelFactors } from "selectors/modelMetadata"
import { getFactorCategory, getFactorLabel } from "helpers/factors"

export const getDisabled = state => get(state, "modules.securityProfileFactorSensitivity.disabled")
const getRawDisplayType = state => get(state, "modules.securityProfileFactorSensitivity.displayType")

export const getDisplayType = createSelector(
  [getRawDisplayType, getModelCategories],
  computeDisplayType,
)

export const getAllItems = createSelector(
  [getModelFactors, getCurrent, getDisabled, getFavoriteFactors],
  (factorsMetadata, lastDatum, disabled, favoriteFactors) => chain(lastDatum)
    .get("factors")
    .map((value, id) => ({
      id,
      label: getFactorLabel(factorsMetadata, id),
      category: getFactorCategory(factorsMetadata, id),
      favorite: favoriteFactors[id],
      lastValue: value,
      field: `factors.${id}`,
      disabled: !!disabled[id],
    }))
    .value(),
)

export const getAllCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => {
    return chain(items)
      .filter(item => item.category === displayType)
      .orderBy(item => Math.abs(item.lastValue), ["desc"])
      .value()
  },
)

export const getOrderedCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy([item => item.favorite, item => Math.abs(item.lastValue)], ["asc", "desc"])
    .value(),
)
